import FormField from 'components/FormField';
import { DisabledProps, FV, PlatformProps, ScenarioTypeProps } from './share';
import { useTranslate } from '@tolgee/react';
import { FilterNegativeBuyer, isFilterNegativeBuyerScenarioSupport } from './FilterNegativeBuyer';
import {
  FilterConsultBuyer,
  isFilterEnable1ScenarioType,
  isFilterEnable3ScenarioType,
} from './FilterConsultBuyer';
import {
  FilterEasyRefundBuyer,
  isFilterEasyRefundBuyerScenarioSupport,
} from './FilterEasyRefundBuyer';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';

function FilterRuleField({
  scenarioType,
  platform,
  disabled = false,
}: DisabledProps & ScenarioTypeProps & PlatformProps) {
  const { t } = useTranslate();
  const { whiteListConfig: { SHOPEE_ZDPF = false } = {} } = useOrgConfigStateValue();

  const filterConsultBuyerVisible =
    isFilterEnable1ScenarioType(scenarioType) || isFilterEnable3ScenarioType(scenarioType);
  // 特殊处理:
  // 催下单场景下, 差评买家表单被合并到售后买家的 FormItem 内
  const filterNegativeBuyerVisible =
    isFilterNegativeBuyerScenarioSupport(scenarioType, platform) &&
    scenarioType !== 'ORDER_REMINDER';

  const filterEasyRefundBuyerVisible =
    isFilterEasyRefundBuyerScenarioSupport(scenarioType, platform) && SHOPEE_ZDPF;

  if (!filterConsultBuyerVisible && !filterNegativeBuyerVisible) {
    return null;
  }

  return (
    <FormField<FV['filterRule']> required name="filterRule" label={t('aide.过滤规则')}>
      {({ field: { value, onChange, onBlur }, meta: { touched } }) => {
        const { filterConsultBuyer, filterNegativeBuyer, filterRegularRefundBuyer } = value || {};

        return (
          <div className="flex flex-col gap-2">
            {filterConsultBuyerVisible && (
              <FilterConsultBuyer
                disabled={disabled}
                touched={touched}
                platform={platform}
                scenarioType={scenarioType}
                filterConsultBuyer={filterConsultBuyer}
                onChange={(filter) => {
                  onChange({
                    filterConsultBuyer: filter,
                    filterNegativeBuyer,
                    filterRegularRefundBuyer,
                  });
                  onBlur();
                }}
              />
            )}
            <FilterNegativeBuyer
              platform={platform}
              scenarioType={scenarioType}
              checked={filterNegativeBuyer}
              onChange={(checked) => {
                onChange({
                  filterConsultBuyer,
                  filterNegativeBuyer: checked,
                  filterRegularRefundBuyer,
                });

                onBlur();
              }}
            />
            {filterEasyRefundBuyerVisible && (
              <FilterEasyRefundBuyer
                platform={platform}
                scenarioType={scenarioType}
                checked={filterRegularRefundBuyer}
                onChange={(checked) => {
                  onChange({
                    filterConsultBuyer,
                    filterNegativeBuyer,
                    filterRegularRefundBuyer: checked,
                  });

                  onBlur();
                }}
              />
            )}
          </div>
        );
      }}
    </FormField>
  );
}

export default FilterRuleField;
